var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    class: _vm.outlined ? 'px-2' : '',
    attrs: {
      "flat": "",
      "outlined": _vm.outlined
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap mt-2 mb-1"
  }, [!_vm.hideSuggestions ? _c('v-chip', {
    staticClass: "ma-1",
    attrs: {
      "color": _vm.selectedCategory === _vm.SUGGESTION ? 'info' : ''
    },
    on: {
      "click": function click($event) {
        _vm.selectedCategory = _vm.SUGGESTION;
      }
    }
  }, [_c('span', {
    staticClass: "mr-1",
    staticStyle: {
      "margin-top": "-2px"
    }
  }, [_c('a-eicon', {
    attrs: {
      "noColor": true
    }
  })], 1), _vm._v(" " + _vm._s(_vm.$t("common.nouns.suggestion")) + " ")]) : _vm._e(), _vm._l(_vm.selectableCategories, function (cat) {
    return _c('v-chip', {
      key: 'refs-select-cats' + cat,
      staticClass: "mr-1 mb-1",
      attrs: {
        "color": _vm.selectedCategory === cat ? 'info' : ''
      },
      domProps: {
        "textContent": _vm._s(_vm.getRefTypeName(cat))
      },
      on: {
        "click": function click($event) {
          _vm.selectedCategory = cat;
        }
      }
    });
  })], 2), _vm.SUGGESTION === _vm.selectedCategory && !_vm.hideSuggestions ? _c('refs-selection-suggestion', {
    attrs: {
      "loading": _vm.loading,
      "suggested": _vm.suggested,
      "selected": _vm.selected,
      "partnerId": _vm.partnerId
    },
    on: {
      "select": _vm.addToSelected
    }
  }) : _vm._e(), Object.values(_vm.BackendResourceEnum).includes(_vm.selectedCategory) ? _c('refs-selection-by-type', {
    key: 'refs-select-by-type' + _vm.selectedCategory,
    attrs: {
      "refType": _vm.selectedCategory,
      "partnerId": _vm.partnerId,
      "selected": _vm.selected,
      "suggested": _vm.suggested,
      "filters": _vm.filters
    },
    on: {
      "select": function select(item) {
        return _vm.addToSelected({
          id: item.id,
          ref: item,
          refType: _vm.selectedCategory
        });
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }